<template>
  <div class="benefits-empty-state">
    <div class="benefits-empty-examples" aria-hidden="true" :style="{ '--bg-opacity': bgOpacity }">
      <slot name="background"></slot>
    </div>

    <div class="benefits-empty-content">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>

      <KvButton class="benefits-empty-create-button" type="button" :prepend-icon="buttonIcon" icon-size="5"
        @click="$emit('action')">
        {{ buttonText }}
      </KvButton>
    </div>
  </div>
</template>

<script>
export default {
  name: "BenefitsEmptyState",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    buttonText: { type: String, required: true },
    buttonIcon: { type: String, default: "ui-plus" },
    bgOpacity: { type: [Number, String], default: 0.5 },
  },
};
</script>

<style lang="scss" scoped>
.benefits-empty-state {
  min-height: 400px;
  position: relative;
  width: 100%;
}

.benefits-empty-examples {
  display: flex;
  flex-direction: column;
  filter: blur(0.9px);
  gap: 12px;
  inset: 0;
  opacity: var(--bg-opacity, 0.5);
  overflow: hidden;
  position: absolute;
}

.benefits-empty-examples::after {
  background: linear-gradient(180deg, rgba(252, 252, 253, 0) 65%, #fcfcfd 100%);
  content: "";
  inset: 0;
  position: absolute;
}

.benefits-empty-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  left: 50%;
  max-width: 560px;
  position: absolute;
  text-align: center;
  top: 60%;
  transform: translate(-50%, -50%);
  width: min(560px, calc(100% - 48px));
  z-index: 1;

  h3 {
    color: #384250;
    font-family: "Sora", sans-serif;
    font-size: 24px;
    font-weight: 400;
    line-height: 1.3;
    margin: 0;
  }

  p {
    color: #4d5761;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    margin: 0;
  }
}

.benefits-empty-create-button {
  background: #2aaa4c;
  border-color: #2aaa4c;
  color: #f1fcf3;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  height: 44px;
  justify-content: center;
  line-height: 1.2;
  padding: 12px;
  width: clamp(432px, 72%, 560px);
}

.benefits-empty-create-button::v-deep .kv-button-content {
  gap: 4px;
}

@media (max-width: 767px) {
  .benefits-empty-state {
    min-height: 320px;
  }

  .benefits-empty-content {
    width: min(100%, calc(100% - 24px));

    h3 {
      font-size: 22px;
    }
  }
}

@media (max-width: 480px) {
  .benefits-empty-create-button {
    font-size: 15px;
    width: 100%;
  }
}
</style>
